
<label class="container-offre col-3">
  <input
    type="radio"
    :aria-checked="content.codePromo"
    :checked="isChecked"
    name="radio"
    :value="content.codePromo"
    @click="sendCodePromo"
    @keydown.space.prevent="sendCodePromo"
  />
  <span class="checkmark text-center my-0" v-html="content.libOffre" />
  <b-img-lazy
    :src="urlImage()"
    class="image-fond h-100 w-100"
    :alt="content.altImage ? content.altImage : ''"
  />
</label>
